/**
 * Phone validation utility
 * Accepts international formats: +33, 0033, +32, +946, etc.
 * Rejects plain text
 */

// Regex: starts optionally with +, then 1-4 digits (country code), then digits/spaces/dots/dashes
export const phoneRegex = /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\./0-9]*$/

/**
 * Validates a phone number
 * @param phone - The phone number to validate
 * @param minLength - Minimum length (default: 8)
 * @returns true if valid, false otherwise
 */
export const isValidPhone = (phone: string, minLength = 10): boolean => {
    if (!phone) return false
    const trimmed = phone.trim()

    // Check basic regex format first
    if (!phoneRegex.test(trimmed)) return false

    // Extract only digits
    const digits = trimmed.replace(/\D/g, '')

    // Rule 1: Minimum length (default 10 for France/International)
    if (digits.length < minLength) return false

    // Rule 2: Anti-spam (reject "0000000000", "111111...", etc.)
    if (/^(\d)\1+$/.test(digits)) return false

    // Rule 3: Anti-spam (reject sequential "0123456789" or "9876543210")
    const sequences = ["0123456789", "1234567890", "9876543210", "0987654321"]
    if (sequences.some(seq => digits.includes(seq))) return false

    return true
}

/**
 * HTML pattern attribute for phone input
 * Use with: pattern={phonePattern}
 */
export const phonePattern = "^[\\+]?[(]?[0-9]{1,4}[)]?[-\\s\\./0-9]*$"

/**
 * Error message for invalid phone
 */
export const phoneErrorMessage = "Veuillez entrer un numéro de téléphone valide (ex: 06 12 34 56 78 ou +33 6 12 34 56 78)"
